<template>
  <div class="pa-3">
    <MenuCategories />
    <v-card class="mt-5" v-if="category">
      <v-card-title class="text-h2">
        {{ category.name }}
      </v-card-title>
      <v-card-text>

      <!-- Specials Tiles -->
      <v-row class="mt-3 mb-5 pl-2" v-if="categoryProducts.length > 0">
        <v-col v-for="product in categoryProducts" :key="product.id" cols="12" sm="3">
          <MasterProductCard :item="product" />
        </v-col>
      </v-row>
      <v-row v-else class="mt-3 mb-5 pl-2">
        <v-col cols="12">
          No products found
        </v-col>
      </v-row>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import MenuCategories from '@/components/MenuCategories.vue';
import MasterProductCard from '../components/MasterProductCard.vue';

export default {
  name: 'CategoryPage',
  components: {
    MenuCategories,
    MasterProductCard,
  },
  meta: {
    breadcrumb:
      [{
        text: 'menu.home',
        to: { name: 'app-Home' },
      }],
  },
  data() {
    return {
      categoryId: this.$route.query.category,
      products: [],
    };
  },
  computed: {
    ...mapState('categories', ['category']),
    ...mapGetters('masterProducts', ['getMasterProductsWithShops', 'specials']),
    categoryProducts() {
      return this.getMasterProductsWithShops
        .filter((p) => p.categoryId === this.categoryId);
    },
  },
  watch: {
    '$route.query.category': {
      immediate: true,
      handler(categoryId) {
        this.categoryId = categoryId;
        this.refresh();
      },
    },
  },
  mounted() {
    this.refresh();
    console.debug(this.$route);
  },
  methods: {
    ...mapActions('categories', ['LOAD_category']),
    ...mapActions('masterProducts', ['LOAD_masterProductsExpanded']),
    async refresh() {
      await this.LOAD_category(this.categoryId);
      this.$root.$emit('update-breadcrumbs', [{
        text: 'menu.home',
        to: { name: 'app-Home' },
      }, {
        text: this.category.name,
        to: { name: 'products-CategoryPage', query: { category: this.categoryId } },
      }]);
      this.products = await this.LOAD_masterProductsExpanded();
    },
  },
};
</script>
